import React from "react";
import "../ResultCard.scss";
interface ISectionProps {
  title?: string;
  subtitle: string;
  others: string;
  children?: any;
  isRTLClass?: boolean;
}
const SubSections: React.FC<ISectionProps> = ({
  title,
  subtitle,
  others,
  children,
  isRTLClass
}) => {
  return (
    <>
      <div className="result-card-sections">
        <div className="result-card-std-title">{title}</div>
        <div className={`result-card-std-subtitle ${isRTLClass ? 'rtl_subtitle_ameniities' : ''}`}>
          {children} 
        </div>
      </div>
    </>
  );
};

export default SubSections;
